<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-also-by element-with-heading" id="also-by-anita-waller">
<div class="heading heading-with-title heading-without-image" id="also-by-anita-waller-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Anita Waller</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-anita-waller-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="first-phrase"><span class="drop-cap">B</span>eautiful</span></p>
<p class="subsq also-by-content">Angel</p>
<p class="subsq also-by-content">Winterscroft</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content"><span class="first-phrase"><span class="drop-cap">3</span>4</span> Days</p>
<p class="subsq also-by-content">Strategy  - The gripping sequel to 34 <span class="last-word">Days</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-anita-waller.vue?685eaa6c